import React from "react";
import PropTypes from "prop-types";

const columnOptions = Array.from({ length: 12 }, (_, i) => (i + 1).toString()).concat(
  Array.from({ length: 12 }, (_, i) => i + 1)
);

const Column = ({
  hide,
  col,
  md,
  lg,
  xl,
  xs,
  className = "",
  children,
  ...rest
}) => {
  if (hide) {
    return null;
  }

  const classes = [
    col ? `col-${col}` : "",
    md ? `col-md-${md}` : "",
    lg ? `col-lg-${lg}` : "",
    xl ? `col-xl-${xl}` : "",
    xs ? `col-xs-${xs}` : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div {...rest} className={classes}>
      {children}
    </div>
  );
};

Column.propTypes = {
  hide: PropTypes.bool,
  col: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  md: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  lg: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  xl: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  xs: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
  children: PropTypes.node,
};

export default Column;



// WEBPACK FOOTER //
// ./src/design-system/layout/Column/Column.jsx